import * as Sentry from '@sentry/browser';
import { useCallback } from 'react';

const useSentryCaptureException = () => {
  const sentryCaptureException = useCallback((error: Error) => {
    Sentry.captureException(error);
  }, []);

  return sentryCaptureException;
};

export default useSentryCaptureException;
